import React from 'react';

import {
  Dialog,
  IconButton,
  DialogTitle,
  withStyles,
  WithStyles,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import {I18n} from 'react-redux-i18n';
import SetupTOTPForm from '../SetupTOTPForm/SetupTOTPForm';

import style from './style';

type SetupTOTPModalProps = WithStyles<typeof style> & {
  open: boolean;
  onClose?: () => void;
  onSuccess: () => void;
};

function SetupTOTPModal({
  classes,
  open,
  onClose,
  onSuccess,
}: SetupTOTPModalProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
    >
      <div className={classes.header}>
        <DialogTitle className={classes.title}>
          {I18n.t('totp.setup.title')}
        </DialogTitle>
        {onClose && (
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        )}
      </div>

      <SetupTOTPForm
        onSuccess={onSuccess}
      />
    </Dialog>
  );
}

export default withStyles(style)(SetupTOTPModal);
